import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
import { Button } from '../../button/src';
export var ToggleIcon = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, label = _a.label, _b = _a.extraClass, extraClass = _b === void 0 ? '' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var classes = new LegacyClassBuilder('awsui-app-layout')
        .addClass('awsui-app-layout__toggle-icon')
        .addClass(extraClass)
        .toClassName();
    return (AwsUi.__createElement("span", { className: classes, onclick: onClick },
        AwsUi.__createElement(Button, { label: label, icon: icon, variant: "icon", formAction: "none", click: onClick, disabled: !!disabled, __ariaExpanded: "false" })));
};
//# sourceMappingURL=toggle-icon.js.map